import styled from "styled-components";

export const OptInBanner = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 1rem;
    margin-bottom: 1rem;
    gap: 0.75rem;
  }
`;

export const OptInIconWrapper = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: #dcfce7;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #16a34a;
`;

export const OptInContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const OptInTitle = styled.h3`
  font-size: 0.9375rem;
  font-weight: 600;
  color: #14532d;
  margin: 0;
  margin-bottom: 0.375rem;
  line-height: 1.3;
`;

export const OptInBody = styled.p`
  font-size: 0.8125rem;
  color: #166534;
  margin: 0;
  margin-bottom: 1rem;
  line-height: 1.5;
`;

export const OptInActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const OptInActivateButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #16a34a;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #15803d;
  }
`;

export const OptInDismissButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: transparent;
  color: #166534;
  border: none;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #dcfce7;
  }
`;
